import { UPLOAD_OR_LINK_MODES, UploadOrLinkMode } from "constants/booksHandoff";

export const isUploadOrLinkMode = (value: unknown): value is UploadOrLinkMode =>
  UPLOAD_OR_LINK_MODES.some((mode) => mode === value);
